const westernDigits = '0123456789';
const persianDigits = '۰۱۲۳۴۵۶۷۸۹';

export function toPersianDigits(value: string | number): string {
  return String(value).replace(/[0-9]/g, (digit) => persianDigits[westernDigits.indexOf(digit)] ?? digit);
}

export function formatFaNumber(value: number): string {
  return value.toLocaleString('fa-IR');
}

export function formatFaText(value: string): string {
  return toPersianDigits(value);
}

export function formatFaRatio(current: number, total: number): string {
  return `${formatFaNumber(current)} از ${formatFaNumber(total)}`;
}

export function formatFaClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return toPersianDigits(`${minutes}:${String(seconds).padStart(2, '0')}`);
}
